import { useState } from 'react'
import './index.css'
import Icon from '../icon'
import ContextMenu from '../../holders/contextmenu'
import API from "../../../api"

function Header({ className, title, contextMenuConfig }) {

  var [showContextMenu, setShowContextMenu] = useState(false)

  const defaultContextMenuConfig = [
    {
      name: 'Reload Page',
      onClick: () => { window.location.reload() }
    }
  ]

  var cmConfig = [...(contextMenuConfig || {}), ...defaultContextMenuConfig]

  return (
    <div className="header-holder">

      <div className={`header ${className || ""}`}>
        <div className='header-left'>
          <div className='header-title'>{title}</div>
        </div>

        {!title && <div className='header-text'>
          <img className='header-logo' src='/logo.png' />
        </div>}

        <div className='header-right'>
          <div>
            <Icon name="more-vert" color="white" onClick={() => { setShowContextMenu(true) }} />
            {showContextMenu &&
              <ContextMenu
                orientation="left"
                close={() => { setShowContextMenu(false) }}
                config={cmConfig}>
              </ContextMenu>
            }
          </div>
        </div>

      </div>

    </div>
  );
}

export default Header;
